import type { ApiClient } from './client.js';

export interface DayOfSchoolApi {
  list(classroomId: string): Promise<number[]>;
  replace(classroomId: string, days: number[]): Promise<number[]>;
}

export function createDayOfSchoolApi(client: ApiClient): DayOfSchoolApi {
  return {
    async list(classroomId) {
      const res = await client.get<{ days: number[] }>(
        `/api/classrooms/${classroomId}/marked-days`,
      );
      return res.days;
    },
    async replace(classroomId, days) {
      const res = await client.put<{ days: number[] }>(
        `/api/classrooms/${classroomId}/marked-days`,
        { days },
      );
      return res.days;
    },
  };
}
